import FileUploader from './FileUploader';

export default FileUploader;



// WEBPACK FOOTER //
// ./src/components/FileUploader/index.js